import moment from "moment/moment";
import { useParams } from "react-router-dom";
import { usePageTitle } from "../../hooks/usePageTitle";
import PlayerLoader from "../../Loader/student/PlayerLoader";
import { useGetVideoQuery } from "../../redux/features/video/videoApi";
import AssignmentButtonInPlayer from "../assignment/AssignmentButtonInPlayer";
import QuizButtonInPlayer from "../quiz/QuizButtonInPlayer";
import Error from "../ui/Error";
import NotFound from "../ui/NotFound";

export default function Player() {
    const { videoId } = useParams();
    usePageTitle(`Course Player`);
    const { data: video, isLoading, isError } = useGetVideoQuery(videoId);

    //  decide what to render
    let content = null;
    if (isLoading) { content = <PlayerLoader /> }
    else if (!isLoading && isError) { content = <Error message="There was error ocurred" isPadding={true} /> }
    else if (!isLoading && !isError && !video?.id) {
        content = <NotFound message={"No video Found"} isPadding={true} />
    }
    else if (!isLoading && !isError && video?.id) {
        const { id, url, title, description, createdAt } = video;

        content = <div className="col-span-full w-full space-y-8 lg:col-span-2">
            <iframe width="100%" className="aspect-video" src={url}
                title={title}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen></iframe>

            <div>
                <h1 className="text-lg font-semibold tracking-tight text-slate-100">
                    {title}
                </h1>
                <h2 className=" pb-4 text-sm leading-[1.7142857] text-slate-400">
                    Uploaded on {moment(createdAt).format("DD MMM YYYY")}</h2>

                <div className="flex gap-4">
                    <AssignmentButtonInPlayer videoId={videoId} />
                    <QuizButtonInPlayer videoId={id} />
                </div>
                <p className="mt-4 text-sm text-slate-400 leading-6">
                    {description}
                </p>
            </div>
        </div>
    }

    return content
};

